import React, { useMemo, useState } from 'react';
import './ModernDisclosure.css';

const buildPanelId = () =>
  `md_${Math.random().toString(36).slice(2)}_${Date.now().toString(36)}`;

const Chevron = ({ className = "" }) => (
  <svg
    className={className}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M5 7.5L10 12.5L15 7.5"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ModernDisclosure = ({
  tone = "default",
  title,
  subtitle,
  chips = [],
  right,
  defaultOpen = false,
  children,
}) => {
  const [open, setOpen] = useState(Boolean(defaultOpen));
  const panelId = useMemo(() => buildPanelId(), []);
  const rootClassName = [
    "modernDisclosure",
    tone === "removed" ? "modernDisclosure--removed" : "",
    open ? "modernDisclosure--open" : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <section className={rootClassName}>
      <div
        className="modernDisclosure__header"
        onClick={() => setOpen((prev) => !prev)}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            setOpen((prev) => !prev);
          }
        }}
        aria-expanded={open}
        aria-controls={panelId}
        role="button"
        tabIndex={0}
      >
        <div className="modernDisclosure__main">
          <div className="modernDisclosure__titleRow">
            <div className="modernDisclosure__title">{title}</div>
            {Array.isArray(chips) && chips.length > 0 && (
              <div className="modernDisclosure__chips">
                {chips.map((chip, idx) => {
                  const label = typeof chip === "string" ? chip : chip?.label;
                  const variant = typeof chip === "string" ? "default" : chip?.variant;
                  if (!label) return null;
                  const chipClassName = [
                    "modernDisclosure__chip",
                    variant === "removed" ? "modernDisclosure__chip--removed" : "",
                  ]
                    .filter(Boolean)
                    .join(" ");
                  return (
                    <span key={`${label}-${idx}`} className={chipClassName}>
                      {label}
                    </span>
                  );
                })}
              </div>
            )}
          </div>
          {subtitle ? <div className="modernDisclosure__subtitle">{subtitle}</div> : null}
        </div>

        {right ? (
          <div
            className="modernDisclosure__right"
            onClick={(e) => e.stopPropagation()}
            onKeyDown={(e) => e.stopPropagation()}
          >
            {right}
          </div>
        ) : null}

        <Chevron className="modernDisclosure__chevron" />
      </div>

      <div id={panelId} className="modernDisclosure__panel" role="region">
        <div className="modernDisclosure__panelInner">
          <div className="modernDisclosure__panelBody">{children}</div>
        </div>
      </div>
    </section>
  );
};

export default ModernDisclosure;
